<script lang="ts">
    import {
        Accordion,
        AccordionSection,
        Button
    } from 'attractions';
    import {
        ChevronDownIcon
    } from 'svelte-feather-icons';
</script>
<style lang="scss">
    li {
      padding:10px 0;
    }
</style>
<h2>Pilabor Dev-Tools</h2>

<p>My personal set of development tools - all pure JavaScript / WASM, client side and no uploads or network traffic. Every tab contains a separate tool.</p>


<Accordion let:closeOtherPanels>
    <AccordionSection on:panel-open={closeOtherPanels} let:toggle>
        <div slot="handle">
            <Button on:click={toggle}>
                External tools
                <ChevronDownIcon size="20" class="ml accordion-chevron"/>
            </Button>
        </div>
<p>Although my personal toolset is growing constantly, sometimes there are better tools out there, than I could create myself. In this case, I'll put it in the list of external tools  below:</p>

<h3>External Tools:</h3>
<ul>
<li><a href="https://jwt.io/" target="_blank">jwt.io</a> - JWT decoder and verifier</li>
<li><a href="https://www.pngtosvg.com/" target="_blank">pngtosvg.com</a> - Convert PNG to SVG images</li>
    <li><a href="https://regex101.com/">regex101.com</a> - online regex tester</li>
    <li><a href="https://www.db-fiddle.com/">db-fiddle.com</a> / <a href="http://sqlfiddle.com/">sqlfiddle.com</a> - online database fiddling</li>
    <li><a href="https://www.photopea.com/">photopea.com</a> - online photoshop</li>
    <li><a href="https://crontab.guru/">crontab.guru</a> - tool for cron jobs</li>
    <li><a href="https://textik.com/">textik.com</a> - ascii art diagram editor</li>
</ul>
    </AccordionSection>
</Accordion>
